import AsyncSelect from "react-select/async";
import { FC } from "react";
import { gql, useLazyQuery } from "@apollo/client";

const SEARCH_COLLECTIONS = gql`
  query SearchCollections($search: String!, $first: Int!) {
    collections(search: $search, first: $first) {
      edges {
        node {
          dbId
          name
        }
      }
    }
  }
`;

interface CollectionChooserProps {
  fieldLabel: string;
  fieldSchema?: { description?: string };
  isMulti?: boolean;
  defaultOptions?: any[];
  value: any;
  onChange: (selected: any) => void;
  [key: string]: any;
}

const CollectionChooser: FC<CollectionChooserProps> = ({
  fieldLabel,
  fieldSchema,
  isMulti = false,
  defaultOptions = [],
  value,
  onChange,
  ...commonProps
}) => {
  const [searchCollections] = useLazyQuery(SEARCH_COLLECTIONS);

  const loadOptions = async (inputValue: string) => {
    try {
      const { data } = await searchCollections({
        variables: { 
          search: inputValue || "",
          first: 10
        }
      });

      if (!data?.collections?.edges) {
        return [];
      }

      return data.collections.edges.map((edge: any) => ({
        value: edge.node.dbId,
        label: edge.node.name
      }));
    } catch (error) {
      console.error('Error loading collections:', error);
      return [];
    }
  };

  return (
    <div {...commonProps}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {fieldLabel}
      </label>
      <AsyncSelect
        isMulti={isMulti}
        cacheOptions
        defaultOptions={[]}
        value={value || []}
        onChange={onChange}
        loadOptions={loadOptions}
        className="react-select-container"
        classNamePrefix="react-select"
        placeholder="Search collections..."
        noOptionsMessage={() => "No collections found"}
        loadingMessage={() => "Loading collections..."}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999
          })
        }}
      />
      {fieldSchema?.description && (
        <p className="mt-1 text-sm text-gray-500">{fieldSchema.description}</p>
      )}
    </div>
  );
};

export default CollectionChooser;
